import React, {Component} from 'react';
import {Link} from 'react-router'
import {connect} from 'react-redux';
import {bindActionCreators} from 'redux';
import * as pageActions from '../../../actions/page';
import DataTable from '../../../components/data-table/data-table';
import LocalizedStrings from '../../../localization/strings';

class PartnersContainer extends Component {

    componentWillMount() {
        this.fetch({});
    }
    removePage(page) {
        if (confirm(LocalizedStrings.doYouWantToRemove)) {
            this.props.actions.deletePage(page);
        }
    }

    fetch(params) {
        const fetchParams = {
            ...this.state,
            ...params
        }
        this.setState(fetchParams);
        this.props.actions.fetchPagesPaginated(fetchParams.page, fetchParams.size);
    }

    render() {
        const {items, total, page, loading, total_pages} = this.props.pages;

        var config = {
            cols: [
                {
                    value: 'title_lt',
                    header: LocalizedStrings.title
                },
                {
                    value: (item)=>{
                        return <div >
                            LT: <Link to={`/page/${item.slug_lt}`}>{`/page/${item.slug_lt}`}</Link> <br/>
                            EN: <Link to={`/page/${item.slug_en}`}>{`/page/${item.slug_en}`}</Link>
                        </div>
                    },
                    header: LocalizedStrings.linkToPage
                },
                {
                    value: (item)=>{
                        return item.show_in_footer ? LocalizedStrings.yes : LocalizedStrings.no;
                    },
                    header: LocalizedStrings.showInFooter
                },
                {
                    value: 'order',
                    header: LocalizedStrings.order
                },
                {
                    value: (item) => {
                        return (
                            <div className="btn-group">
                                <Link to={`/admin/pages/${item.id}`} className="btn">{LocalizedStrings.edit}</Link>
                                <Link to={`/page/${item.slug}`} className="btn">{LocalizedStrings.preview}</Link>
                                <a className="btn btn-red" onClick={this.removePage.bind(this, item)}>{LocalizedStrings.delete}</a>
                            </div>
                        )
                    },
                    header: LocalizedStrings.actions
                }
            ]
        };
        return (
            <div>
                <h3>{LocalizedStrings.pages}</h3>
                <div className="table-actions-row">
                    <Link to="/admin/pages/new" className="btn btn-primary">
                        {LocalizedStrings.newPage}
                    </Link>
                </div>
                <div className="panel">
                    <div className="panel-body">
                        <DataTable config={config} items={items} page={page} total={total} totalPages={total_pages} loadAction={this.fetch.bind(this)} loading={loading}></DataTable>
                    </div>
                </div>
            </div>

        )
    }
}

export default connect(function(state) {
    return {pages: state.page.pages};
}, function(dispatch) {
    return {
        actions: bindActionCreators({
            ...pageActions
        }, dispatch)
    };
})(PartnersContainer);



// WEBPACK FOOTER //
// ./src/js/containers/admin/page/pages-container.js